var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 9.07422C16.5312 9.2234 16.472 9.36648 16.3665 9.47197C16.261 9.57746 16.1179 9.63672 15.9688 9.63672H10.3438V15.2617C10.3438 15.4109 10.2845 15.554 10.179 15.6595C10.0735 15.765 9.93043 15.8242 9.78125 15.8242C9.63207 15.8242 9.48899 15.765 9.3835 15.6595C9.27801 15.554 9.21875 15.4109 9.21875 15.2617V9.63672H3.59375C3.44457 9.63672 3.30149 9.57746 3.196 9.47197C3.09051 9.36648 3.03125 9.2234 3.03125 9.07422C3.03125 8.92503 3.09051 8.78196 3.196 8.67647C3.30149 8.57098 3.44457 8.51172 3.59375 8.51172H9.21875V2.88672C9.21875 2.73753 9.27801 2.59446 9.3835 2.48897C9.48899 2.38348 9.63207 2.32422 9.78125 2.32422C9.93043 2.32422 10.0735 2.38348 10.179 2.48897C10.2845 2.59446 10.3438 2.73753 10.3438 2.88672V8.51172H15.9688C16.1179 8.51172 16.261 8.57098 16.3665 8.67647C16.472 8.78196 16.5312 8.92503 16.5312 9.07422Z",
    fill: "#45852E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.d7cce310f7965b7c72a84ec7faf2fc39.svg";
export { ForwardRef as ReactComponent };